import  { APIClient } from "../api";
//import { SurveyCustomer, SurveyAttendant } from "../../models/SurveyCustomer"

export default class SurveyCustomerService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async saveSurveyCustomer(surveyCustomer: any) {
        const url = this.endpoint + `/SurveyCustomer`;

        return this.api({
            method: 'post',
            url, 
            data: surveyCustomer
        })
    }

    async saveSurveyAttendant(surveyAttendant: any) {
        const url = this.endpoint + `/SurveyCustomer/SaveSurveyAttendant/`;

        return this.api({
            method: 'post',
            url, 
            data: surveyAttendant
        })
    }

    async retrieveSurveyCustomer(solicitationId: number) {
        // const url = this.endpoint + `/SurveyCustomer`;
        const url = this.endpoint + `/SurveyCustomer?$filter=id eq ${solicitationId}`;

        const params_ = {
            $filter: 'Id eq ' + solicitationId
         };

        return this.api({
            method: 'get',
            url, 
            // params: params_,
        })
    }

    async getSurveyAttendant(solicitationId: number) {
        const url = this.endpoint + `/SurveyCustomer/GetSurveyAttendant/${solicitationId}`;

        return this.api({
            method: 'get',
            url, 
        })
    }

    async getUserFromSurveyAttendant(solicitationId: number) {
        const url = this.endpoint + `/SurveyCustomer/GetUserFromSurveyAttendant/${solicitationId}`;

        return this.api({
            method: 'get',
            url, 
        })
    }

    async getBusinessAreaFromSolicitation(solicitationId: number) {
        const url = this.endpoint + `/SurveyCustomer/GetBusinessAreaFromSolicitation/${solicitationId}`;

        return this.api({
            method: 'get',
            url, 
        })
    }

    async getUserFromLastWork(solicitationId: number) {
        const url = this.endpoint + `/SurveyCustomer/GetUserFromLastWork/${solicitationId}`;

        return this.api({
            method: 'get',
            url, 
        })
    }
}